<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null,
      fill: false
    },
    height: Number
  },
  data() {
    return {
      options: {
        //Chart.js options
        scales: {
          yAxes: [
            {
              id: "amount",
              ticks: {
                beginAtZero: true
              },
              lineFill: false
            },
            {
              id: "count",
              position: "right",
              ticks: {
                beginAtZero: true
              },
              lineFill: false
            }
          ],
          xAxes: [
            {
              display: true,
              labelString: "Count",
              type: "time",
              time: {
                unit: "month",
                displayFormats: {
                  quarter: "MMM YYYY"
                }
              },
              lineFill: false
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>